import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { Component, forwardRef } from '@wordpress/element';
/**
 * Internal dependencies
 */

import Button from '../button';
import Icon from '../icon';
import { G, Path, SVG } from '../primitives';
export var PanelBody =
/*#__PURE__*/
function (_Component) {
  _inherits(PanelBody, _Component);

  function PanelBody(props) {
    var _this;

    _classCallCheck(this, PanelBody);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PanelBody).apply(this, arguments));
    _this.state = {
      opened: props.initialOpen === undefined ? true : props.initialOpen
    };
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PanelBody, [{
    key: "toggle",
    value: function toggle(event) {
      event.preventDefault();

      if (this.props.opened === undefined) {
        this.setState(function (state) {
          return {
            opened: !state.opened
          };
        });
      }

      if (this.props.onToggle) {
        this.props.onToggle();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          children = _this$props.children,
          opened = _this$props.opened,
          className = _this$props.className,
          icon = _this$props.icon,
          forwardedRef = _this$props.forwardedRef;
      var isOpened = opened === undefined ? this.state.opened : opened;
      var classes = classnames('components-panel__body', className, {
        'is-opened': isOpened
      });
      return createElement("div", {
        className: classes,
        ref: forwardedRef
      }, !!title && createElement("h2", {
        className: "components-panel__body-title"
      }, createElement(Button, {
        className: "components-panel__body-toggle",
        onClick: this.toggle,
        "aria-expanded": isOpened
      }, createElement("span", {
        "aria-hidden": "true"
      }, isOpened ? createElement(SVG, {
        className: "components-panel__arrow",
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      }, createElement(G, null, createElement(Path, {
        fill: "none",
        d: "M0,0h24v24H0V0z"
      })), createElement(G, null, createElement(Path, {
        d: "M12,8l-6,6l1.41,1.41L12,10.83l4.59,4.58L18,14L12,8z"
      }))) : createElement(SVG, {
        className: "components-panel__arrow",
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      }, createElement(G, null, createElement(Path, {
        fill: "none",
        d: "M0,0h24v24H0V0z"
      })), createElement(G, null, createElement(Path, {
        d: "M7.41,8.59L12,13.17l4.59-4.58L18,10l-6,6l-6-6L7.41,8.59z"
      })))), title, icon && createElement(Icon, {
        icon: icon,
        className: "components-panel__icon",
        size: 20
      }))), isOpened && children);
    }
  }]);

  return PanelBody;
}(Component);

var forwardedPanelBody = function forwardedPanelBody(props, ref) {
  return createElement(PanelBody, _extends({}, props, {
    forwardedRef: ref
  }));
};

forwardedPanelBody.displayName = 'PanelBody';
export default forwardRef(forwardedPanelBody);
//# sourceMappingURL=body.js.map